module.exports = __webpack_public_path__ + "static/media/kotlin.1078bfd6.svg";